import { Configuration, PublicClientApplication } from '@azure/msal-browser';

const clientId = process.env.VUE_APP_CLIENT_ID;
const authority = process.env.VUE_APP_AUTHORITY;
const redirectUri = process.env.VUE_APP_URL_REDIRECT;

const msalConfig: Configuration = {
  auth: {
    clientId: clientId!,
    authority: authority,
    redirectUri: redirectUri
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: true
  }
};

export const msalInstance = new PublicClientApplication(msalConfig);
